module.exports = __webpack_public_path__ + "static/media/client_work.7404142b.jpg";